import { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";
import Header from "./Header";
// import { FaRobot } from "react-icons/fa6";
import { CONST } from '../../../../_config';
import { authHeader } from '../../../../_helpers';

export default function LayoutWrap({
  children
}) {

  const [collapsed, setCollapsed] = useState(
    window.innerWidth < 768
  );

  // ✅ NEW STATE FOR API DATA
  const [insightData, setInsightData] = useState(null);

  useEffect(() => {
    const resize = () => {
      if (window.innerWidth < 768) setCollapsed(true);
    };

    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);


  const onLogout = async () => {
    try {
      await axios.post(
        `${CONST.BACKEND_EMPROLE_URL}/logoutSession`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: authHeader().Authorization,
          },
        }
      );
      // ✅ साफ़ करो session
      localStorage.clear();
      sessionStorage.clear();
      // ✅ redirect
      window.location.href = "#/insight/signin";
    } catch (err) {
      console.error("Logout failed:", err);
      // even if API fails → force logout
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "#/insight/signin";
    }
  };

  useEffect(() => {
    const fetchInsightUser = async () => {
      try {
        const value = {}; // 👉 put your payload here if needed

        const res = await axios.post(
          `${CONST.BACKEND_EMPROLE_URL}/getInsightUser`,
          value, // ✅ body
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: authHeader().Authorization, // ✅ auth
            },
          }
        );

        setInsightData(res.data);
      } catch (err) {
        console.error("Error fetching insight user:", err);
      }
    };

    fetchInsightUser();
  }, []);

  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <>
      {/* first and main  */}
      {/* <div className="flex h-screen bg-gray-50 overflow-hidden relative">
        <div className="flex flex-col flex-1 min-w-0">
          <Sidebar
            collapsed={collapsed}
            setCollapsed={setCollapsed}
          />
          <div className={`flex flex-col flex-1 transition-all duration-300 ml-0 ${collapsed ? "md:ml-20" : "md:ml-64"}`}>
            <Header
              collapsed={collapsed}
              toggleSidebar={toggleSidebar}
              onLogout={onLogout}
              userDetails={insightData?.data || {}}
            />

            <main className="flex-1 overflow-y-auto mt-20 min-h-0 bg-white">
              {children}
            </main>
          </div>
        </div>
      </div> */}

      {/* second attempt */}
      {/* <div className="flex h-screen bg-gray-50 overflow-hidden relative">
        <div className="flex flex-col flex-1 min-w-0">
          <Sidebar
            collapsed={collapsed}
            setCollapsed={setCollapsed}
          />
          <div
            className={`flex flex-col flex-1 transition-all duration-300 ml-0 ${collapsed ? "md:ml-20" : "md:ml-64"
              }`}
          >
            <Header
              collapsed={collapsed}
              toggleSidebar={toggleSidebar}
              onLogout={onLogout}
              userDetails={insightData?.data || {}}
            />
            <main className="flex-1 min-h-0 pt-20 bg-white overflow-hidden">
              {children}
            </main>
          </div>
        </div>
      </div> */}


      <div className="flex h-screen bg-gray-50 overflow-hidden relative">

        {/* 🔥 IMPORTANT: padding-top for fixed header */}
        <div className="flex flex-col flex-1 min-w-0 pt-20">

          {/* SIDEBAR */}
          <Sidebar
            collapsed={collapsed}
            setCollapsed={setCollapsed}
          />

          {/* MAIN AREA */}
          <div
            className={`flex flex-col flex-1 min-w-0 transition-all duration-300 ${collapsed ? "md:ml-20" : "md:ml-64"
              }`}
          >
            {/* HEADER (fixed already) */}
            <Header
              collapsed={collapsed}
              toggleSidebar={toggleSidebar}
              onLogout={onLogout}
              userDetails={insightData?.data || {}}
            />

            {/* ✅ MAIN CONTENT */}
            <main className="flex-1 min-h-0 overflow-hidden bg-white">
              {children}
            </main>

          </div>
        </div>
      </div>
    </>

  );
}